import { render, staticRenderFns } from "./wrapperCriteria.vue?vue&type=template&id=59bd5438&"
import script from "./wrapperCriteria.vue?vue&type=script&lang=js&"
export * from "./wrapperCriteria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports